/* eslint-disable react/jsx-no-useless-fragment */
import { useEffect, useState } from '@wordpress/element';
import { Table } from 'semantic-ui-react';
import { slugify } from './Utils';

function CountryTable({ d, selectedSurvey, selectedCountry, selectedYear }) {
	const [displayTable, setDisplayTable] = useState(true);
	const {
		survey,
		country,
		year,
		designEffect,
		fieldworkDates,
		language,
		marginError,
		mode,
		primaryVendor,
		representative,
		sampleDesign,
		sampleSize,
		weightingVariables,
	} = d;
	const surveySlug = slugify(survey);
	const countrySlug = slugify(country);
	const yearSlug = slugify(year);
	useEffect(() => {
		if ('all-survey' !== selectedSurvey && selectedSurvey !== surveySlug) {
			setDisplayTable(false);
			return;
		}
		if ('all-country' !== selectedCountry && selectedCountry !== countrySlug) {
			setDisplayTable(false);
			return;
		}
		if ('all-year' !== selectedYear && selectedYear !== yearSlug) {
			setDisplayTable(false);
			return;
		}
		setDisplayTable(true);
	}, [selectedSurvey, selectedCountry, selectedYear]);
	return (
		<>
			{displayTable && (
				<Table
					className="database__table"
					celled
					columns={2}
					fixed
					compact
					stackable={false}
				>
					<Table.Header>
						<Table.Row>
							<Table.HeaderCell>
								<Table.Cell>Country:</Table.Cell>
							</Table.HeaderCell>
							<Table.HeaderCell>
								<Table.Cell>{country}</Table.Cell>
							</Table.HeaderCell>
						</Table.Row>
					</Table.Header>
					<Table.Body>
						<Table.Row>
							<Table.Cell>Year:</Table.Cell>
							<Table.Cell>{year}</Table.Cell>
						</Table.Row>
						<Table.Row>
							<Table.Cell>Survey:</Table.Cell>
							<Table.Cell>{survey}</Table.Cell>
						</Table.Row>
						<Table.Row>
							<Table.Cell>Sample design:</Table.Cell>
							<Table.Cell>{sampleDesign}</Table.Cell>
						</Table.Row>
						<Table.Row>
							<Table.Cell>Mode:</Table.Cell>
							<Table.Cell>{mode}</Table.Cell>
						</Table.Row>
						<Table.Row>
							<Table.Cell>Language:</Table.Cell>
							<Table.Cell>{language}</Table.Cell>
						</Table.Row>
						<Table.Row>
							<Table.Cell>Fieldwork dates:</Table.Cell>
							<Table.Cell>{fieldworkDates}</Table.Cell>
						</Table.Row>
						<Table.Row>
							<Table.Cell>Sample size:</Table.Cell>
							<Table.Cell>{sampleSize}</Table.Cell>
						</Table.Row>
						<Table.Row>
							<Table.Cell>Margin of error:</Table.Cell>
							<Table.Cell>{marginError}</Table.Cell>
						</Table.Row>
						<Table.Row>
							<Table.Cell>Representative:</Table.Cell>
							<Table.Cell>{representative}</Table.Cell>
						</Table.Row>
						<Table.Row>
							<Table.Cell>Primary vendor:</Table.Cell>
							<Table.Cell>{primaryVendor}</Table.Cell>
						</Table.Row>
						<Table.Row>
							<Table.Cell>Weighting variables:</Table.Cell>
							<Table.Cell>{weightingVariables}</Table.Cell>
						</Table.Row>
						<Table.Row>
							<Table.Cell>Design effects:</Table.Cell>
							<Table.Cell>{designEffect}</Table.Cell>
						</Table.Row>
					</Table.Body>
				</Table>
			)}
		</>
	);
}

export default CountryTable;
